"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YeastForms = exports.YeastTypes = void 0;
exports.YeastTypes = {
    ale: 'Ale',
    lager: 'Lager',
    wheat: 'Wheat',
    wine: 'Wine',
    champagne: 'Champagne',
};
exports.YeastForms = {
    liquid: 'Liquid',
    dry: 'Dry',
    slant: 'Slant',
    culture: 'Culture',
};
//# sourceMappingURL=yeast.js.map